import * as _ from 'lodash-es';
import React from 'react';
import type { PillSize } from '../components/Pill';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import Link from '../utils/router/Link';
import TopicPill from './TopicPill';
import * as styles from './TopicPills.module.scss';

const TOPIC_FRAGMENT = gql(`
  fragment TopicPills_topics on Topic {
    id
    ...TopicPill_topic
  }
`);

interface TopicPillsProps {
  limit?: number;
  moreLink?: string;
  onRemove?: () => unknown;
  showHoverCard?: boolean;
  topics: DocumentType<typeof TOPIC_FRAGMENT>[];
  names?: Array<string | undefined>;
  highlighted?: boolean;
  size?: PillSize;
}

const TopicPills = ({
  limit,
  moreLink,
  topics,
  names,
  ...props
}: TopicPillsProps) => {
  const items = _.zip(topics, names ?? []);

  const displayedItems = limit != null ? items.slice(0, limit) : items;
  const moreCount = items.length - displayedItems.length;
  const moreContent = `+ ${moreCount} more`;

  return (
    <div className={styles.pills}>
      {displayedItems.map(
        ([topic, name]) =>
          topic && (
            <div key={topic.id} className={styles.child}>
              <TopicPill topic={topic} name={name} {...props} />
            </div>
          ),
      )}
      {moreCount > 0 && (
        <div className={styles.child}>
          {moreLink ? (
            <Link className={styles.more} to={moreLink}>
              {moreContent}
            </Link>
          ) : (
            <span className={styles.more}>{moreContent}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default TopicPills;
